import { Loader2, LockKeyhole } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FieldSelect } from '@/components/ui/field-select';
import type { SocialComment, SocialPost } from '@/lib/social/types';

type Lane = NonNullable<SocialComment['lane']>;

export function ReplyFooter({ post, lane, onLaneChange, editing, busy, canSubmit, length }: {
  post: SocialPost; lane: Lane; onLaneChange: (lane: Lane) => void;
  editing: boolean; busy: boolean; canSubmit: boolean; length: number;
}) {
  return <div className="social-reply-footer">
    <div className="social-reply-footer-options">
      {(post.visibility === 'followers' || post.author.private) && <span className="social-reply-audience" title="Followers only"><LockKeyhole aria-hidden="true" /><span>Followers only</span></span>}
      {(post.kind === 'feedback' || lane !== 'conversation') && <FieldSelect aria-label="Feedback category" icon={false} className="max-w-36 text-xs" value={lane} disabled={editing || busy} onChange={event => onLaneChange(event.target.value as Lane)}>
        <option value="conversation">Conversation</option><option value="keep">Keep</option><option value="try">Try</option><option value="question">Question</option>
      </FieldSelect>}
    </div>
    <div className="social-reply-submit"><span className="social-reply-counter" aria-label={`${length} of 1000 characters`}>{length}/1,000</span><Button type="submit" disabled={!canSubmit} className="rounded-full px-5">{busy && <Loader2 className="size-4 animate-spin" />}{busy ? 'Posting…' : editing ? 'Save reply' : 'Reply'}</Button></div>
  </div>;
}
